import { Component, inject, Inject, signal } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Filters, MainFilterOption } from '../../models';
import { FilterAccordionComponent } from '../filter-accordion/filter-accordion.component';
import { FilterService } from '../../filter.service';

@Component({
  templateUrl: 'bottom-sheet-filter-accordion-wrapper.component.html',
  standalone: true,
  imports: [MatBottomSheetModule, FilterAccordionComponent],
  providers: [FilterService],
})
export class BottomSheetFilterAccordionWrapperComponent {
  protected filters = signal<Filters>({});

  private bottomSheetRef = inject(MatBottomSheetRef<BottomSheetFilterAccordionWrapperComponent>);
  private readonly filterService = inject(FilterService);

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { filters: Filters; filterOptions: MainFilterOption[] },
  ) {
    this.filters.set(data.filters);
  }

  protected clearFilters(): void {
    this.filters.set({});
    this.bottomSheetRef.dismiss(this.filters());
  }

  protected toggleFilter(key: string, value: string | boolean): void {
    const newFilters = this.filterService.toggleFilter(this.filters(), key, value);
    if (newFilters) {
      this.filters.set({ ...newFilters });
    }
  }

  protected applyFilters(): void {
    this.bottomSheetRef.dismiss(this.filters());
  }

  protected closeWithoutSaving(): void {
    this.bottomSheetRef.dismiss();
  }
}
